export const LOGIN_RETURN_PARAM = 'next'

// Only the OAuth consent page sends a signed-out visitor back where they
// came from: it carries the authorization request an MCP client is waiting
// on. Every other page has always landed on `/` after sign-in.
const RETURN_AFTER_LOGIN_PREFIXES = ['/oauth/']

const returnsAfterLogin = (pathname: string): boolean =>
  RETURN_AFTER_LOGIN_PREFIXES.some((prefix) => pathname.startsWith(prefix))

export function loginReturnPathFor(
  pathname: string,
  search: string,
): string | undefined {
  return returnsAfterLogin(pathname) ? `${pathname}${search}` : undefined
}

// A path that starts with two slashes or a slash and a backslash is
// protocol-relative to a browser: `//evil.example` leaves the site.
const PROTOCOL_RELATIVE = /^\/[/\\]/

// The parameter arrives in a URL anyone can craft. The check runs on the
// path as the URL parser normalizes it, since that is what the browser is
// sent to: `/.//evil.example` normalizes to `//evil.example`.
export function safeLoginReturnPath(
  next: string | null,
  origin: string,
): string | undefined {
  if (!next?.startsWith('/')) {
    return undefined
  }
  try {
    const url = new URL(next, origin)
    const path = `${url.pathname}${url.search}${url.hash}`
    return url.origin === origin &&
      !PROTOCOL_RELATIVE.test(path) &&
      returnsAfterLogin(url.pathname)
      ? path
      : undefined
  } catch {
    return undefined
  }
}
